<template>
  <zm-dialog
    ref="dialog"
    v-bind="$attrs"
    v-on="$listeners"
    class="opc-dialog"
    :class="{
      'opc-modal-dialog': isModal,
      'opc-modal-dialog__without-title': (isModal && notHasTitle)
    }"
    :show-close="!isModal"
  >
    <template v-for="(_, slotName) in $scopedSlots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps"></slot>
    </template>
  </zm-dialog>
</template>

<script>
import Vue from 'vue';
import NavBack from '@/components/nav-back.vue';

export default {
  name: 'BillingDialog',
  inheritAttrs: false,
  data() {
    return {
      navBackInstance: null,
    };
  },
  computed: {
    isModal() {
      return this.$context?.is?.modal;
    },
    notHasTitle() {
      return !(this.$scopedSlots.title || this.$attrs.title);
    }
  },
  methods: {
    handleBeforeClose() {
      this.$emit('back-event');
    },
    injectNavBack() {
      const dialogWrapper = this.$refs.dialog?.$el;
      const innerDialog = dialogWrapper?.querySelector('.zm-dialog');

      if (!innerDialog) return;
      if (this.navBackInstance) return;

      const NavBackConstructor = Vue.extend(NavBack);
      const instance = new NavBackConstructor({
        propsData: {
          backHandler: this.handleBeforeClose,
        },
      });

      instance.$mount();
      instance.$el.classList.add('opc-modal-dialog__nav-back');

      innerDialog.insertBefore(instance.$el, innerDialog.firstChild);
      this.navBackInstance = instance;
    },
    removeNavBack() {
      if (this.navBackInstance) {
        this.navBackInstance.$destroy();
        this.navBackInstance.$el.remove();
        this.navBackInstance = null;
      }
    },
  },
  watch: {
    isModal(val) {
      if (val) {
        this.$nextTick(this.injectNavBack);
      } else {
        this.removeNavBack();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isModal) {
        this.injectNavBack();
      }
    });
  },
  beforeDestroy() {
    this.removeNavBack();
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import "@/styles/modal.scss";

.opc-modal-dialog {
  &__nav-back {
    margin-bottom: 24px;
  }

  &__without-title {
    .zm-dialog {
      .zm-dialog__header {
        padding: 0px;
      }
    }
  }
}

</style>
